module.exports = __webpack_public_path__ + "img/lg-ecomdy-tiktok.50afdead.svg";